import { useState } from "react";
import { OutputAsset } from "@forgepoint/shared";
import { AssetChip } from "@/components/AssetChip";
import { AssetPreviewDialog } from "@/components/AssetPreviewDialog";

/**
 * Displays a list of assets as clickable chips with a preview dialog.
 * Clicking a chip opens the asset in a dialog with AssetFileViewer and a download button.
 *
 * @param assets - Array of OutputAsset objects to display
 */
export const AssetDisplay = ({ assets }: { assets: OutputAsset[] }) => {
  const [selectedAsset, setSelectedAsset] = useState<OutputAsset | null>(null);

  if (assets.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-wrap gap-2 mb-2">
        {assets.map((asset) => (
          <AssetChip
            key={asset.id}
            asset={asset}
            onClick={() => setSelectedAsset(asset)}
          />
        ))}
      </div>

      <AssetPreviewDialog
        assetId={selectedAsset?.id ?? null}
        fileName={selectedAsset?.fileName}
        onClose={() => setSelectedAsset(null)}
      />
    </>
  );
};
